export enum MobileMainView {
    PANEL = "panel",
    CHARTING = "charting",
    TRADEDESK ="tradedesk",
    SCANNER = "scanner",
    SHOP = "shop"
}